import { render, staticRenderFns } from "./TreatmentSpotSelectTemplate.vue?vue&type=template&id=1972dc4a&scoped=true&"
import script from "./TreatmentSpotSelectTemplate.vue?vue&type=script&lang=ts&"
export * from "./TreatmentSpotSelectTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentSpotSelectTemplate.vue?vue&type=style&index=0&id=1972dc4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972dc4a",
  null
  
)

export default component.exports